import {
  Avatar,
  Box,
  Button,
  Group,
  SimpleGrid,
  Switch,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { MerchData } from "../../../../types/types";
import classes from "./Merchants.module.css";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import { useFilterReset } from "../../../TableSort/FilterGroup/FilterResetContext";
import {
  IconCircleCheckFilled,
  IconCircleXFilled,
  IconInfoCircleFilled,
} from "@tabler/icons-react";

interface MerchantsProps {
  data?: MerchData[];
}

export default function Merchants(props: MerchantsProps) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<MerchData[]>(props.data ?? []);
  const [active, setActive] = useState<number>();
  const { triggerReset } = useFilterReset();
  const theme = useMantineTheme();
  console.log("merchdata: ", data);

  // set the active merchant on startup if active is undefined (prevent
  // infinite loop)
  useEffect(() => {
    if (active === undefined) {
      const foundIndex = data.findIndex((item) => item.active);
      if (foundIndex !== -1) {
        setActive(foundIndex);
      }
    }
  }, [data, active]);

  async function handleSetActive(index: number) {
    if (active === undefined) {
      console.warn("Active index is undefined");
      return;
    }
    console.log("handling set active: " + data[active!].id);
    try {
      setLoading(!false); // fok u Luke
      setLoading(true); // You're welcome Alex :)
      const response = await fetch(
        window.location.origin +
          "/server/client_service/active-merchant?id=" +
          data[index].id,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({
          //   merchantID:
          // }),
        }
      );
      const resData = await response.json();
      console.log("resData", resData);

      if (!response.ok) {
        throw new Error("Failed to activate merchant");
      } else {
        // merchant updated successfully, change active merch in data for reload
        setData((prevData) => {
          const updatedData = [...prevData];
          updatedData[active].active = false;
          updatedData[index].active = true;
          return updatedData;
        });
        setActive(index);
        triggerReset();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {!loading ? (
        data.length > 0 ? (
          data.map((merch, index) => (
            <Group wrap="nowrap" mb="md">
              <Avatar src={merch.logo_url} size={94} radius="md" />
              <div>
                <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                  Merchant Name
                </Text>

                <Text fz="lg" fw={500} className={classes.name}>
                  {merch.name}
                </Text>

                <Group wrap="nowrap" gap={5} mt={3}>
                  {merch.active ? (
                    <IconCircleCheckFilled
                      stroke={1.5}
                      color={theme.colors.blue[6]}
                      size={16}
                      className={classes.icon}
                    />
                  ) : (
                    <IconCircleXFilled
                      stroke={1.5}
                      size={16}
                      color="grey"
                      className={classes.icon}
                    />
                  )}
                  <Text fz="xs" c="dimmed">
                    {merch.active === true ? "active" : "inactive"}
                  </Text>
                </Group>
              </div>
              <Button
                variant="gradient"
                gradient={{ from: "#00ddb3", to: "#00ddb3", deg: 125 }}
                ml="auto"
                size="sm"
                disabled={active === index}
                onClick={(event) => handleSetActive(index)}
              >
                Switch
              </Button>
            </Group>
            // <Group
            //   justify="space-between"
            //   className={classes.item}
            //   wrap="nowrap"
            //   gap="xl"
            //   key={merch.name}
            // >
            //   <div>
            //     <Text>{merch.name}</Text>
            //   </div>
            //   <Button
            //     disabled={active === index}
            //     onClick={(event) => handleSetActive(index)}
            //   >
            //     {merch.active === true ? "active" : "switch"}
            //   </Button>
            // </Group>
          ))
        ) : (
          <div>No Merchants To Display</div>
        )
      ) : (
        <LoadingSpinner size="xs" color="blue" h="20vh" />
      )}
    </>
  );
}
